import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Icon',
    name: 'icon',
    type: FIELD_TYPES.AI_ICONS,
    defaultValue: '911HangUp.png',
  },
  { label: 'Layer Url', name: 'url', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Type',
    name: 'type',
    type: FIELD_TYPES.SELECT,
    options: [
      { label: 'Feature', value: 'feature' },
      { label: 'Image', value: 'image' },
    ],
    defaultValue: 'feature',
  },
  {
    label: 'Popup Template',
    name: 'popupTemplate',
    type: FIELD_TYPES.TEXT_AREA,
    rows: 10,
    defaultValue: '',
  },
]
